export default __webpack_public_path__ + "static/SSSpyView_screenshot-5@mob2x-da2728f1d9303d459e07811dfb914e9e.jpg";